<ng-container *transloco="let t; read: 'admin.tenants.inviteDialog'">
  <app-modal
    [(open)]="open"
    [title]="tenantName ? t('titleNamed', { name: tenantName }) : t('title')"
    size="medium"
    (closed)="onClose()"
  >
    <form (ngSubmit)="onSubmit()" class="space-y-4">
      <app-form-field [label]="t('email')" [help]="t('emailHelp')">
        <app-text-input [placeholder]="t('emailPlaceholder')" [(ngModel)]="email" name="email" required></app-text-input>
      </app-form-field>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <app-form-field [label]="t('firstName')">
          <app-text-input [(ngModel)]="firstName" name="firstName"></app-text-input>
        </app-form-field>
        <app-form-field [label]="t('lastName')">
          <app-text-input [(ngModel)]="lastName" name="lastName"></app-text-input>
        </app-form-field>
      </div>

      <app-form-field [label]="t('role')" [help]="selectedRoleDescription() || t('roleHelp')">
        @if (rolesUnavailable()) {
          <app-text-input [placeholder]="t('rolePlaceholder')" [(ngModel)]="role" name="role" required></app-text-input>
        } @else {
          <app-select
            [(ngModel)]="role"
            name="role"
            [options]="roleOptions()"
            [placeholder]="t('selectRole')"
            [disabled]="rolesLoading()"
          ></app-select>
        }
      </app-form-field>
    </form>

    <ng-template modalFooter>
      <div class="flex flex-1 items-center justify-end gap-2">
        <button type="button" (click)="onClose()"
          class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken">
          {{ t('cancel') }}
        </button>
        <button type="button" (click)="onSubmit()" [disabled]="!isValid || isSending()"
          class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90">
          {{ t('send') }}
        </button>
      </div>
    </ng-template>
  </app-modal>
</ng-container>
